import { render } from "./QaboardManage.vue?vue&type=template&id=0e319bc4&scoped=true"
import script from "./QaboardManage.vue?vue&type=script&lang=ts"
export * from "./QaboardManage.vue?vue&type=script&lang=ts"

import "./QaboardManage.vue?vue&type=style&index=0&id=0e319bc4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e319bc4"

export default script